module.exports = __webpack_public_path__ + "static/media/GGcardstep3.45a3b861.svg";